import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {},
  },
  iconButtonScrollRight: {
    variant: 'unstyled',
    bgGradient:
      'linear(to-b, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
    color: 'beta.400',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    border: 'none',
    h: 9,
    w: 4,
    mt: 'px',
    minW: 'unset',
    borderRightRadius: 'base',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {},
  },
  iconButtonScrollLeft: {
    variant: 'unstyled',
    bgGradient:
      'linear(to-b, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
    color: 'beta.400',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    border: 'none',
    h: 9,
    w: 4,
    mt: 'px',
    minW: 'unset',
    borderLeftRadius: 'base',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    bg: 'alpha.700',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    borderRadius: 'base',
    display: 'inline-flex',
    flex: '1',
    overflowX: 'auto',
    pl: '1',
    pt: '0.5',
    spacing: '1',
    whiteSpace: 'nowrap',
    sx: { '::-webkit-scrollbar': { display: 'none' } },
    pb: '1',
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    mx: '1',
    gap: 1,
    isAttached: true,
  },
};
